/* eslint-disable indent */

import { DefineOwnModule, RootActions } from 'stores/type';
import StorageManager, { StorageKey } from 'managers/storage.manager';
import { NEW, FAIL } from 'constants/mix-result';
import { State, Getters, Actions, Mutations } from './types';

const DEFAULT_STATE = {
  firstLaunch: Date.now(),
  sessionsCount: 1,
  session: {
    initialProgress: 0,
    start: Date.now(),
    streak: 0,
    fails: 0,
    failsStreak: 0,
  },
};

const moduleState: State = {
  ...DEFAULT_STATE,
  ...StorageManager.load(StorageKey.STATS) || {},
};

const storeModule: DefineOwnModule<
  State,
  Getters,
  Mutations,
  Actions & Pick<RootActions, 'mixOccured' | 'resetProgress'>
> = {
  state: moduleState,

  getters: {
    firstLaunch: (state) => state.firstLaunch,
    sessionsCount: (state) => state.sessionsCount,
    sessionStats: (state) => state.session,
    sessionFailStreak: (state) => state.session.failsStreak,
    sessionFails: (state) => state.session.fails,
    sessionStreak: (state) => state.session.streak,
  },

  actions: {
    statsSessionsCount({ commit }) {
      commit('STATS_SESSIONS');
    },
    statsInitialProgress({ commit, getters }) {
      commit('STATS_INITIAL_PROGRESS', getters.totalProgress);
    },
    mixOccured({ commit }, { status }) {
      if (status === NEW) {
        commit('STATS_MIX_NEW');
      } else if (status === FAIL) {
        commit('STATS_MIX_FAIL');
      }
    },
    resetProgress({ dispatch }) {
      dispatch('statsInitialProgress');
    },
  },

  mutations: {
    STATS_SESSIONS(state) {
      state.sessionsCount++;
    },
    STATS_INITIAL_PROGRESS(state, progress) {
      state.session.initialProgress = progress;
    },
    STATS_MIX_NEW(state) {
      state.session.streak++;

      state.session.failsStreak = 0;
    },
    STATS_MIX_FAIL(state) {
      state.session.streak = 0;

      state.session.failsStreak++;
      state.session.fails++;
    },
  },
};

export default storeModule;
